import * as React from 'react';

import { CustomEventNames } from 'state/cdp/constants';

import { RewardsLink as RewardsLinkBase } from './rewards-link.base';

export const RewardsLink = () => (
  <RewardsLinkBase onClickEventName={CustomEventNames.BUTTON_CLICK_BK_REWARDS} />
);
